import { format } from "date-fns";

export const formatDateTrimmed = ISODate => {
  if (!ISODate) return null;
  return format(new Date(ISODate), "MMMM do");
};
